<template>
  <svg width="18"
       height="20"
       viewBox="0 0 18 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M1.96875 15.4639H16.0225C16.9277 15.4639 17.4814 14.9717 17.4814 14.2334C17.4814 13.3018 16.6377 12.502 15.8467 11.7461C15.2227 11.1396 15.082 9.87402 14.9678 8.70508C14.8271 5.48828 13.8867 3.2207 11.6104 2.40332C11.25 1.24316 10.292 0.34668 8.99121 0.34668C7.69922 0.34668 6.74121 1.24316 6.37207 2.40332C4.10449 3.2207 3.15527 5.48828 3.02344 8.70508C2.90918 9.87402 2.75977 11.1396 2.14453 11.7461C1.35352 12.502 0.509766 13.3018 0.509766 14.2334C0.509766 14.9717 1.06348 15.4639 1.96875 15.4639ZM8.99121 19.085C10.5557 19.085 11.6895 17.9688 11.8037 16.6943H6.1875C6.30176 17.9688 7.43555 19.085 8.99121 19.085Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'BellIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    },
    iconClass: {
      type: String,
      default: ''
    }
  }

}
</script>

<style>

</style>
